import styled, { keyframes } from 'styled-components'

const fadeIn = keyframes`
  0% { opacity: 0;}
  100% { opacity: 100;}
`

export const Container = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  opacity: 0;
  /* background: rgba(17, 36, 38, 0.8); */
  background: linear-gradient(40deg, rgba(0,0,0,0.7469362745098039) 0%, rgba(0,0,0,0.5732668067226891) 35%, rgba(0,0,0,0) 100%);
  animation: ${fadeIn} .3s ease forwards;
  z-index: 10;
  &.open {
    opacity: 1;
    display: block;
    transition: all .5s ease;
    display: flex;
    justify-content: center;
  }

  &.closed {
    display: none;
    opacity: 0;
    pointer-events: none; 
    touch-action: none;
    transition: all .5s ease-out;
  }
`

export const ContainerImageVideo = styled.div`
    width: auto;
    max-width: 90%;

    @media (min-width: 768px) {
        max-width: 94%;
        padding: 8px;
        &.video{
            max-width: 100%;
            min-height: 300px;
            margin-bottom: -6px;

            iframe {
                min-height: 300px;
            }
        }
    }  
    
`

export const BtnClose = styled.div`
    position: absolute;
    top: 15px;
    right: 15px;
    z-index: 10;

    svg {
        width: 28px;
        height: 28px;
        color: #FFF;
        cursor: pointer;

        @media (min-width: 768px) {
            margin-top: -6px;
            padding: 0;
            width: 32px;
            height: 32px;
        }
    }
`

export const ImageContainer = styled.div`
  height: auto;
  max-height: 36vh;
  /* max-width: 84%; */
  opacity: 0;
  animation: ${fadeIn} .3s ease forwards .2;

  img {
    width: auto;
    max-width: 100%;
    max-height: calc(36vh - 8px);
    border: solid 4px rgba(255,255,255,0.3);
    
  }

  video {
    width: auto;
    max-width: 100%;
    max-height: calc(36vh - 8px);
    border: solid 4px rgba(255,255,255,0.3);
  }

  @media (min-width: 768px) {
    max-height: 36vh;
    max-width: 100%;
  }
`

export const StyledMain = styled.div`
  position: relative;
  width: 100%;
  height: 40vh;
  padding: 0 20px;

  @media (min-width: 768px) {
    width: 50vw;
    padding-left: 94px;
  }

  &.menu-cook {
    height: 58vh;
    overflow: auto;
    overflow-x: hidden;
  }
`;

export const TitleSection = styled.h1`
  font-family: 'Amorim Sans Serif';
  text-transform: uppercase;
  font-size: 30px;
  letter-spacing: 1px;
  border-top: solid 4px #FFF;
  color: #FFF;

  @media (min-width: 768px) {
    font-size: 48px;
  }
`

export const ButtonMenu = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 36px;
  font-size: 18px;
  letter-spacing: 2.2px;
  border-top: solid 1px #FFF;
  margin-bottom: 18px; 
  color: #FFF;
  cursor: pointer;
  padding-right: 6px;

  &.active {
    margin-bottom: 4px; 
    svg {
      transform: rotate(180deg);
    }
  }

  svg {
    transform-origin: center;
    transform: rotate(0deg);
    transition: all .3s ease-out;
  }
`

export const Description = styled.p`
  color: #FFF;
  font-size: 14px;
  letter-spacing: 1px;
  line-height: 24px;
  margin-bottom: 20px;
  opacity: 0;
  animation: ${fadeIn} 1s ease-out forwards;
`
